document.addEventListener('DOMContentLoaded', function() {
  // This javascript file is used to the calculation of the "Dimensionering af fedtudskiller-kuverter" page.

  function calculateFedtudskiller() {
    // Input variables:
    let Vm = parseFloat(document.getElementById('virktype').value) || 0;
    let M = parseFloat(document.querySelector('#maaltider').value) || 0;
    let V = M*Vm;
    let F;
    if (Vm === 100) {
      F = 5;
    } else if (Vm === 50) {
      F = 8.5;
    } else if (Vm === 20) {
      F = 13;
    } else if (Vm === 10) {
      F = 22;
    } else if (Vm === 5) {
      F = 20;
    }
    let t = parseFloat(document.querySelector('#arb_tid').value) || 0;
    let Ft = parseFloat(document.getElementById('tillobstemp').value) || 0;
    let Fd = parseFloat(document.getElementById('densitetsfakt').value) || 0;
    let Fr = parseFloat(document.getElementById('rengoeringsmidler').value) || 0;
    
    // Total output calculation
    let qs = V*F/(3600*t);

    let qud = qs * Ft * Fd * Fr;
    // Defining output variables
    let outputOne = document.querySelector('#total-output-one');
    let outputTwo = document.querySelector('#total-output-two');
    let outputThree = document.querySelector('#total-output-three');


    // Showing output calculations
    if (outputOne) {
      // Round up to nearest 2 decimals
      let qudRoundedUp = Math.ceil(qud * 100) / 100;
      outputOne.textContent = qudRoundedUp.toFixed(2) + ' L/s';
    }
    let qudNS;
    if (outputTwo) {
      if (qud > 0 && qud <= 2) {
        qudNS = '2';
      } else if (qud > 2 && qud <= 4) {
        qudNS = '4';
      } else if (qud > 4 && qud <= 7) {
        qudNS = '7';
      } else if (qud > 7 && qud <= 10) {
        qudNS = '10';
      } else if (qud > 10 && qud <= 15) {
        qudNS = '15';
      } else if (qud > 15) {
        qudNS = 'Speciallavet';
      }
      outputTwo.textContent = qudNS;
    }
    if (outputThree) {
      let qudSF = Number(qudNS) * 100;
      outputThree.textContent = qudSF + ' L';
    }

    // Product recommendation from calculation
    let products = document.querySelectorAll('.product-recommendation-item');
    let fallbackProduct = document.querySelector('.no-product-recommendation-item');

    let bestProduct = null;
    let bestInterval = Infinity; // Start with Infinity since we want the lowest intervalValue above qud

    console.log('qud:', qud);

    products.forEach(function(product, idx) {
      product.classList.forEach(function(className) {
        let match = className.match(/^interval-(\d+)$/);
        if (match) {
          let intervalValue = parseInt(match[1], 10);
          console.log(`Product #${idx} class: ${className}, intervalValue: ${intervalValue}`);
          if (intervalValue >= qud && intervalValue < bestInterval) {
            bestInterval = intervalValue;
            bestProduct = product;
            console.log(`--> New bestProduct found: Product #${idx} with intervalValue ${intervalValue}`);
          }
        }
      });
    });

    console.log('Best interval found:', bestInterval);
    console.log('Best product:', bestProduct);

    // Hide all products first using the 'hidden' class
    products.forEach(function(product) {
      product.classList.add('hidden');
      product.classList.remove('chosen');
    });
    if (fallbackProduct) {
      fallbackProduct.classList.add('hidden');
      fallbackProduct.classList.remove('chosen');
    }

    // Show the best matching product, or fallback if none found
    if (bestProduct) {
      console.log('Showing bestProduct');
      bestProduct.classList.remove('hidden');
      bestProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    } else if (fallbackProduct) {
      console.log('Showing fallbackProduct');
      fallbackProduct.classList.remove('hidden');
      fallbackProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    }

  }

  let submitButton = document.querySelector('#submit-calculation-kuverter');
  if (submitButton) {
    submitButton.addEventListener('click', function(event) {
      event.preventDefault();
      calculateFedtudskiller();
    });
  }

});